<script lang="ts" setup>
import { useForm, useSupport } from '@consumer/composables/support'
import { support } from '@consumer/api'
import { SUPPORT_CATEGORY_ICONS } from '@consumer/modules/support/categoryIcons'
import newMagnifyingGlassIcon from '@consumer/assets/icons/new/magnifying-glass.svg?svgicon'
import newArrowRightIcon from '@consumer/assets/icons/new/arrow-right.svg?svgicon'

const searchForm = useForm({
  keywords: null,
})

const { currentCategory, listCategories } = useSupport()

function searchArticles () {
  return searchForm.get(support.search.path())
}
</script>

<template>
  <GCard rounded shadow class="p-6 space-y-6">
    <form @submit.prevent="searchArticles">
      <GTextInput
        v-model="searchForm.keywords"
        placeholder="Search"
        class="w-full"
        :iconRight="newMagnifyingGlassIcon"
      >
        <template #addonRight>
          <GIcon
            :svg="newMagnifyingGlassIcon"
            color="grey-400"
            class="cursor-pointer hover:stroke-primary-base hover:fill-primary-base stroke-2"
            @click="searchArticles"
          />
        </template>
      </GTextInput>
    </form>
    <h4 class="text-lg">Categories</h4>
    <GLink
      v-for="category, i in listCategories"
      :key="i"
      class="flex gap-4 group items-center"
      :href="support.category.path({ category: category.name })"
    >
      <GIcon
        :icon="SUPPORT_CATEGORY_ICONS[category.icon]"
        size="24px"
        class="
            stroke-2 stroke-grey-500 fill-grey-500
            group-hover:stroke-primary-base group-hover:fill-primary-base
          "
        :class="{
          '!stroke-4 !stroke-primary-base !fill-primary-base': category.name === currentCategory?.name
        }"
      />
      <div
        class="group-hover:text-primary-base flex-1 text-navy"
        :class="{
          '!text-primary-base font-semibold': category.name === currentCategory?.name
        }"
      >
        {{ category.label }}
      </div>
      <GIcon
        v-if="category.name === currentCategory?.name"
        :svg="newArrowRightIcon"
        size="16px"
        color="primary-base"
      />
    </GLink>
  </GCard>
</template>
